import { render, staticRenderFns } from "./PersonalDataForm.vue?vue&type=template&id=61164652&scoped=true&"
import script from "./PersonalDataForm.vue?vue&type=script&lang=js&"
export * from "./PersonalDataForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61164652",
  null
  
)

export default component.exports